import AdminUserStore from './stores/admin-user-store';
import AdminRoleStore from './stores/admin-role-store';
import AdminNetworkStore from './stores/admin-network-store';

const adminStore = {
  state: {
  },
  mutations: {
  },
  actions: {
    async addSoftwareVersion({ dispatch }, payload) {
      // payload is formData
      const result = await fetch('/v2/admin/clientSoftware', { 
        method: 'POST',
        body: payload
      });
      if (result.ok) {
        await dispatch('fetchDeviceSoftwareVersions');
      }
      return result;
    },
    async editSoftwareVersion({ dispatch }, payload) {
      // payload is formData
      const result = await fetch(`/v2/admin/clientSoftware/${payload.id}`, { 
        method: 'PUT',
        body: payload.form
      });
      if (result.ok) {
        await dispatch('fetchDeviceSoftwareVersions');
      }
      return result;
    }
  },
  getters: {
  },
  modules: {
    users: AdminUserStore,
    roles: AdminRoleStore,
    network: AdminNetworkStore
  }
}
export default adminStore;
